import { render, staticRenderFns } from "./DealsListSection.vue?vue&type=template&id=56fc731a&scoped=true&"
import script from "./DealsListSection.vue?vue&type=script&lang=js&"
export * from "./DealsListSection.vue?vue&type=script&lang=js&"
import style0 from "./DealsListSection.vue?vue&type=style&index=0&id=56fc731a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc731a",
  null
  
)

export default component.exports